module.exports = __webpack_public_path__ + "img/loader.99c095c8.svg";